module.exports = __webpack_public_path__ + "static/media/roiHero3x.a59f7f16.png";